<template>
  <div>
    <b-row align-h="center" v-if="settingsLoading">
      <b-spinner
        class="m-5"
        style="width: 4rem; height: 4rem"
        type="grow"
        variant="primary"
        label="Spinning"
      ></b-spinner>
    </b-row>
    <template v-else>
      <MarksEntryOLevel v-if="isClasswiseEnrollment" />
      <MarksEntry v-else />
    </template>
  </div>
</template>

<script>
import { BSpinner, BRow, BCol } from "bootstrap-vue";
import MarksEntry from "./marksEntry.vue";
import MarksEntryOLevel from "./marksEntryOLevel.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BSpinner,
    BRow,
    BCol,
    MarksEntry,
    MarksEntryOLevel,
  },
  data() {
    return {
      settingsLoading: true,
      isClasswiseEnrollment: false,
    };
  },
  created() {
    // console.log("marks redirect");
    this.LoadSettings();
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    async LoadSettings() {
      this.settingsLoading = true;
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["classwise_enrollment"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });

      let obj = res.find((el) => el.key == "classwise_enrollment");
      this.isClasswiseEnrollment = obj && obj.valueBool;
      console.log(this.isClasswiseEnrollment);
      this.settingsLoading = false;
    },
  },
};
</script>
<style></style>
